import { createStoreCreator } from 'lib/store'
import reducer from './reducers'

export default createStoreCreator(reducer, 'ShiftBookNotifications')
